// extracted by mini-css-extract-plugin
export default {"reviewsButton":"Hm1rKFRdQjnIl24aYX5R+w==","reviewsButton_text":"k2tSTdG75i6jtesm44LEAA=="};